import React from "react";
import { NavLink } from "react-router-dom";
import FeatherIcon from "feather-icons-react";

function ManualSidebarLink({ onSelect }) {
  return (
    <li className="nav-item">
      <NavLink
        className="nav-link p-2"
        activeClassName="active"
        exact
        to="/manuel"
        onClick={onSelect}
        title="Ouvrir le manuel d’utilisation"
      >
        <FeatherIcon icon="help-circle" size="16" />
        <span className="ms-2 d-none d-sm-inline">Manuel</span>
      </NavLink>
    </li>
  );
}

export default ManualSidebarLink;
